var exports = {
  "K0": "IconButton__A-RpQh",
  "EY": "Text__P-iu27",
  "N_": "Link__JCa4Zo",
  "az": "Box__eIFUnB",
  "m4": "Octicon__BL4SgW",
};

module.exports = exports;
